import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AuthState {
  token: string | null;
  isLoading: boolean;
  setToken: (token: string) => void;
  clearToken: () => void;
  initialize: () => Promise<void>;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, _get) => ({
      token: null,
      isLoading: true,
      setToken: (token) => { localStorage.setItem('auth-token', token); set({ token }); },
      clearToken: () => { localStorage.removeItem('auth-token'); set({ token: null }); },
      initialize: async () => {
        const stored = localStorage.getItem('auth-token');
        if (stored) set({ token: stored, isLoading: false });
        else set({ isLoading: false });
      },
    }),
    { name: 'auth-storage', partialize: (state) => ({ token: state.token }) }
  )
);